module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('form', {
    attrs: {
      "id": "hcpSearchForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSearch.apply(null, arguments)
      }
    }
  }, [_c('mu-paper', {
    staticClass: "searchBar"
  }, [_c('mu-icon', {
    attrs: {
      "value": "search"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onSearch.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('message.searchText')
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })], 1), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ed5bb04","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HCP/Search.vue
// module id = 3220
// module chunks = 1